export default {
  CUSTOMER_ADDRESS_REPOSITORY: Symbol.for('CUSTOMER_ADDRESS_REPOSITORY'),
  UPDATE_CUSTOMER_ADDRESS_COMMAND: Symbol.for('UPDATE_CUSTOMER_ADDRESS_COMMAND'),
  CUSTOMER_ADDRESS_STATE_MANAGER: Symbol.for('CUSTOMER_ADDRESS_STATE_MANAGER'),
  CHOOSE_YOUR_DOCUMENTS_SERVICE: Symbol.for('CHOOSE_YOUR_DOCUMENTS_SERVICE'),
  ADDRESS_SERVICE: Symbol.for('ADDRESS_SERVICE'),
  PROOF_OF_ADDRESS_SERVICE: Symbol.for('PROOF_OF_ADDRESS_SERVICE'),
};
